import { useState } from "react";
import Link from "next/link";
import { ChevronDown, CarFront, Map, BookHeart, Luggage } from "lucide-react";
import { useRouter } from "next/navigation"; // Importer useRouter
import { HeaderAuth } from "./header-auth";

interface MobileMenuProps {
    isOpen: boolean;
    onClose: () => void;
}

type ParentSubmenuType = string | null;

interface Item {
    name: string;
    href: string;
}
interface SubmenuItem {
    name: string;
    href?: string;
    icon?: React.ReactNode;
    items?: Item[];
}

const navMenu: SubmenuItem[] = [
    {
        name: "Louer un 4x4",
        icon: <CarFront size={16} />,
        href: "/vehicle"
    },
    {
        name: "Voyager en 4x4",
        items: [
            { name: "Checklist avant le départ", href: "/checklist" },
            { name: "Charte du roadtrip responsable", href: "/roadtrip" },
            { name: "Packs assurances sécurisées", href: "/insurance" },
            // { name: "Blog & Conseils voyages", href: "/article" },
        ],
        icon: <Luggage size={16} />,
    },
    // {
    //     name: "Acheter un roadbook",
    //     items: [
    //         { name: "Roadbook 7 jours et +", href: "/roadbook/long" },
    //         { name: "Mini aventure 3 jours et +", href: "/roadbook/short" },
    //     ],
    //     icon: <Map size={16} />,
    // },
    {
        name: "À propos",
        items: [
            { name: "Qui sommes-nous ?", href: "/about" },
            // { name: "Nos partenaires", href: "/partner" },
            { name: "F.A.Q.", href: "/faq" },
            { name: "Contact", href: "/contact" },
        ],
        icon: <BookHeart size={16} />,
    },
];

export default function MobileMenu({ isOpen, onClose }: MobileMenuProps) {
    const [openParentSubmenu, setOpenParentSubmenu] = useState<ParentSubmenuType>(null);
    const router = useRouter(); // Initialiser le router

    function handleMenuItemClick(item: SubmenuItem) {
        if (item.items && item.items.length > 0) {
            // S'il y a des sous-éléments, ouvrir/fermer le sous-menu
            toggleParentSubmenu(item.name);
        } else {
            // Sinon, rediriger vers l'URL et fermer le menu
            if (item.href) {
                router.push(item.href);
                onClose(); // Fermer le menu après la redirection
            }
        }
    }

    function toggleParentSubmenu(name: ParentSubmenuType) {
        setOpenParentSubmenu((prev) => (prev === name ? null : name));
    }

    return (
        <div
            className={`
                        fixed top-[104px] left-0 w-full h-[calc(100vh-104px)] bg-background dark:bg-[#17252A] z-50
                        transform transition-transform duration-300
                        ${isOpen ? "translate-y-0" : "translate-y-full hidden"}
                    `}
        >
            {/* Contenu du menu */}
            <nav className="p-4 flex mid:hidden flex-col items-center justify-center h-full">
                <HeaderAuth isMenuOpen={isOpen} />
                <ul className="space-y-12 text-lg text-primary  w-80">
                    {navMenu.map((item) => (
                        <li key={item.name}>
                            <div
                                onClick={() => handleMenuItemClick(item)}
                                className="flex items-center justify-between w-full py-2 cursor-pointer"
                            >
                                <div className="flex items-center gap-2">
                                    {item.icon}
                                    <span className="text-text font-bold">{item.name}</span>
                                </div>
                                {item.items && item.items.length > 0 && (
                                    <ChevronDown
                                        size={16}
                                        className={`transition-transform ${openParentSubmenu === item.name ? "rotate-180" : ""
                                            }`}
                                    />
                                )}
                            </div>
                            {item.items && openParentSubmenu === item.name && (
                                <ul className="pl-6 mt-2 space-y-2 text-base text-gray-600">
                                    {item.items.map((subItem, index) => (
                                        <li key={index}>
                                            <Link
                                                href={subItem.href!}
                                                onClick={onClose} // Fermer le menu lors du clic sur un sous-item
                                                className="block py-1 text-primary transition-colors duration-200 font-bold"
                                            >
                                                {subItem.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    ))}
                </ul>

                <Link
                    href="/#carte-cadeau"
                    onClick={onClose}
                    className="bg-secondary font-bold rounded-xl mt-12 opacity-90 px-[12px] py-2 border text-background_sd hover:text-background_sd border-background_sd transition-all duration-300 ease-in-ou hover:bg-[#17252A] hover:dark:text-[#17252A] hover:-translate-y-1 active:scale-95 text-center block"
                >
                    Cartes Cadeaux
                </Link>
            </nav>
        </div>
    );
}
